import type { StoreState, SurveyState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Update partial survey theme */
export const updateSurveyTheme =
    (partialSurveyTheme: Partial<SurveyState['theme']>) =>
    (state: StoreState): StoreState =>
        makeSurveyDirty({
            ...state,
            survey: {
                ...state.survey,
                theme: {
                    ...state.survey.theme,
                    ...partialSurveyTheme,
                },
            },
        });
